import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { BaseComponent } from '../../common/base/base.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent extends BaseComponent implements OnInit {
  public isLoading: boolean | undefined;
  public isFixed: boolean = false;

  constructor(private commonService: CommonService) {
    super();
  }

  ngOnInit(): void {
    this.commonService.loading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ isLoading, isFixed }) => {
        this.isLoading = isLoading;
        this.isFixed = isFixed;
      });
  }
}
